import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CoverageDeductibleLimit, SourceSystemType } from '@amfam/policy/models';

@Component({
  selector: 'auto-coverage',
  templateUrl: './auto-coverage.component.html',
  styleUrls: ['./auto-coverage.component.scss', '../policy-risk-card.scss'],
  standalone: false
})
export class AutoCoverageComponent implements OnChanges {
  @Input() isAdvancedCustomer: boolean;
  @Input() coverage: CoverageDeductibleLimit;
  @Input() sourceSystem = SourceSystemType.Advance;
  name: string;

  ngOnChanges(changes: SimpleChanges) {
    this.name =
      this.sourceSystem === SourceSystemType.Legacy
        ? this.coverage.coverage.description
        : this.coverage.coverage.name;
  }
}
